import { getTypedState } from 'ducks/hooks'
import { Appliance, PropertySource7, PropertyDetail, ApplianceType, ApplianceBrands } from 'ducks/types'

export const getPropertyDetail = () => (): PropertyDetail => {
  const { propertyDetail } = getTypedState()
  return propertyDetail
}

export const getPropertySource7 = () => (): PropertySource7 | undefined => {
  const { propertyDetail } = getTypedState()
  return propertyDetail?.propertySource7
}

export const getPropertyAppliances = () => (): Appliance[] => {
  const { propertyDetail: { propertySource7 } } = getTypedState()
  return propertySource7?.appliances || []
}

export const getPropertyApplianceTypes = () => (): ApplianceType => {
  const { propertyDetail: { appliancesTypes } } = getTypedState()
  return appliancesTypes || []
}

export const getPropertyApplianceBrands = () => (): ApplianceBrands => {
  const { propertyDetail: { appliancesBrands } } = getTypedState()
  return appliancesBrands || []
}

export const getPropertyId = () => (): string => {
  const { propertyDetail: { id } } = getTypedState()
  return id
}

export const getPropertyInquiredItems = () => (): string[] => {
  const { propertyDetail: { inquiredItems } } = getTypedState()
  return inquiredItems || []
}
